import React from "react";
import "./ListaDePatrones.css";

export const ListaDePatrones = ({
  disponibles,
  ordenados,
  setOrdenados,
  patronSeleccionado,
  setSeleccionado,
  sorteoSeleccionado,
  setPatronesOrdenados,
}) => {
  const API_URL = process.env.REACT_APP_API_URL;

  const agregar = (patron) => {
    if (!ordenados.find((p) => p._id === patron._id)) {
      setOrdenados([...ordenados, patron]);
    }
  };

  const eliminar = (patronId) => {
    setOrdenados(ordenados.filter((p) => p._id !== patronId));
    if (patronSeleccionado?._id === patronId) {
      setSeleccionado(null);
    }
  };

  const seleccionar = async (patron) => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      console.error("No hay sesión activa");
      return;
    }

    try {
      console.log("URL->", `${API_URL}/activar_patron/${patron._id}`);
      await fetch(`${API_URL}/activar_patron/${patron._id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Guardar selección local inmediata
      setSeleccionado(patron);

      // Inicializar participaciones para el bingo con este patrón
      if (sorteoSeleccionado?.idSorteo || sorteoSeleccionado?._id) {
        const sorteoId = sorteoSeleccionado.idSorteo || sorteoSeleccionado._id;
        try {
          const token = localStorage.getItem("access_token");
          const resParticipaciones = await fetch(
            `${API_URL}/participaciones/iniciar_bingo?sorteo_id=${sorteoId}&patron_id=${patron._id}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          );
          const dataParticipaciones = await resParticipaciones.json();
          console.log("Participaciones inicializadas:", dataParticipaciones);
        } catch (errPart) {
          console.error("Error al inicializar participaciones:", errPart);
        }
      }

      // Refrescar patrones desde backend
      if (sorteoSeleccionado?.idSorteo) {
        const resPatrones = await fetch(
          `${API_URL}/patrones_sorteo/${sorteoSeleccionado.idSorteo}`,
        );
        const patronesData = await resPatrones.json();

        const patronesFormateados = Array.isArray(
          patronesData.patrones_secuencia,
        )
          ? patronesData.patrones_secuencia.map((p, index) => ({
              _id: p._id,
              nombre: p.nombre,
              monto: p.monto || 0,
              activo: p.activo || false,
              orden: index,
            }))
          : [];

        setPatronesOrdenados(patronesFormateados);
      }
    } catch (error) {
      console.error("Error al activar patrón:", error);
    }
  };

  const isStandBy = sorteoSeleccionado?.nombreSorteo === "StandBy";

  return (
    <div>
      {/* Patrones Disponibles */}
      <div className="lista-patrones-section">
        <h4>Patrones Disponibles</h4>
        <div className="disponibles-list">
          {disponibles.map((p) => (
            <div
              key={p._id}
              style={{ display: "flex", alignItems: "center", gap: "4px" }}
            >
              <span className="disponible-chip" onClick={() => agregar(p)}>
                {p.nombre}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Patrones Seleccionados */}
      <div className="lista-patrones-section">
        <h4>Patrones en Secuencia</h4>
        <div className="patrones-grid">
          {ordenados.length === 0 && (
            <div
              style={{ color: "#888", textAlign: "center", padding: "20px" }}
            >
              Agrega patrones de la lista superior
            </div>
          )}
          {ordenados.map((p) => {
            const marcado = isStandBy
              ? false
              : patronSeleccionado?._id === p._id;

            return (
              <div key={p._id} className="patron-item">
                <button
                  onClick={() => seleccionar(p)}
                  disabled={isStandBy ? false : p.activo}
                  className={`patron-btn ${
                    marcado ? "patron-seleccionado" : ""
                  }`}
                >
                  {p.nombre}
                  {marcado && " ✅"}
                </button>
                <span
                  style={{
                    color: "#ffd700",
                    fontWeight: "bold",
                    minWidth: "60px",
                  }}
                >
                  💰 {p.monto}
                </span>
                <input
                  type="number"
                  value={p.monto ?? ""}
                  placeholder="Monto"
                  onChange={(e) => {
                    const nuevoMonto = Number(e.target.value);
                    setPatronesOrdenados((prev) =>
                      prev.map((patron) =>
                        patron._id === p._id
                          ? { ...patron, monto: nuevoMonto }
                          : patron,
                      ),
                    );
                  }}
                />
                <button
                  onClick={() => eliminar(p._id)}
                  style={{
                    background: "#333",
                    border: "none",
                    color: "#ff4444",
                    padding: "8px 12px",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  🗑️
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
